import { render } from "./AddressBookNarrowDown.vue?vue&type=template&id=949a3cde"
import script from "./AddressBookNarrowDown.vue?vue&type=script&lang=ts"
export * from "./AddressBookNarrowDown.vue?vue&type=script&lang=ts"
script.render = render

export default script